export class CarQuoteLitePolicyInfo {
    automaticAdjustment: number;
    commercialAlternative: number;
    terms?: number;
    paymentMethod?: any;
    fee?: CarQuoteLitePaymentFee;
    affinityGroup?: number;
}

export class CarQuoteLitePaymentFee {
    key: number;
    value: string;
    name: string;
}

